module.exports = __webpack_public_path__ + "static/media/refused.1abea198.svg";